<template>
  <div>
    <dx-drop-down-box
      ref="dropDownBox"
      :data-source="departments"
      :defer-rendering="false"
      :drop-down-options="{ width: 500 }"
      :value="selectedKeys"
      :width="'100%'"
      field-template="field"
      placeholder="Подразделение"
      value-expr="kod_direct"
    >
      <template #field>
        <div class="d-flex align-items-center">
          <dx-text-box
            :read-only="true"
            :value="displayExpr(value)"
          />
          <div v-if="showValidation">
            <i id="errorIconDepartment" class="dx-icon dx-icon-info text-danger"></i>
            <dx-tooltip
              :hide-on-outside-click="false"
              :target="'#errorIconDepartment'"
              hide-event="mouseleave"
              position="right"
              show-event="mouseenter"
            >
              {{ validateCode && 'Необходимо выбрать подразделение с кодом МВП или Предприятие' || 'Необходимо выбрать подразделение' }}
            </dx-tooltip>
          </div>
        </div>
      </template>

      <template>
        <dx-tree-list
          ref="treeListRef"
          v-model:selected-row-keys="selectedKeys"
          :columns="columns"
          :data-source="departments"
          :filter-row="{ visible: true }"
          :height="'50vh'"
          :hover-state-enabled="true"
          key-expr="kod_direct"
          parent-id-expr="kod_parent"
          @selection-changed="selectionChanged($event)"
        >
          <dx-selection :mode="selectionMode" />
          <dx-scrolling mode="virtual" />
        </dx-tree-list>
        <div v-if="selectionMode === 'multiple'" class="d-flex">
          <dx-button type="default" class="flex-grow-1 mr-1" @click="() => { dropDownBox.instance.close(); }">Закрыть</dx-button>
          <dx-button type="normal" class="flex-grow-1 ml-1" @click="() => { selectedKeys = [];}">Очистить</dx-button>
        </div>
      </template>
    </dx-drop-down-box>
  </div>
</template>

<script>
export default {
  name: 'mped-department-tree-component',
};
</script>

<script setup>
import { computed, defineEmits, defineExpose, defineModel, onMounted, ref } from 'vue';
import {
  DxTreeList,
  DxScrolling,
  DxSelection,
} from 'devextreme-vue/tree-list';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { DxTooltip, DxTextBox, DxButton } from 'devextreme-vue';

import { getDepartments } from '@/views/mped/services/mped-department-service';

const columns = [{
  caption: 'id',
  dataField: 'kod_direct',
  visible: false
}, {
  caption: 'Наименование',
  dataField: 'name'
}, {
  caption: 'код МВП',
  dataField: 'mvp_code',
  width: 100,
}];
const
  departments = ref([]),
  dropDownBox = ref(),
  treeListRef = ref(),
  selectedKeys = ref([]),
  selectedData = ref([]);
const value = defineModel('value');
const emit = defineEmits(['valueChanged']);

const { defaultValue, validateCode, validateRequired, selectionMode, typeDepartment } = defineProps({
  defaultValue: Number,
  validateCode: {
    type: Boolean,
    default: true
  },
  validateRequired: {
    type: Boolean,
    default: false
  },
  selectionMode: {
    type: String,
    default: 'single'
  },
  typeDepartment: {
    type: String,
    default: 'mvp',
  },
});

const showValidation = computed({
  get: () => (
      (validateRequired || validateCode)
      &&
      (
        (selectionMode === 'single' && !value.value)
        ||
        (selectionMode === 'multiple' && !selectedData.value.length))
    )
    ||
    (
      validateCode
      &&
      (
        (selectionMode === 'single' && !value.value?.mvp_code)
        ||
        (selectionMode === 'multiple' && selectedData.value.find(x => !x.mvp_code))
      )
    )
});

onMounted(async () => {
  departments.value = await getDepartments({ type: typeDepartment });
  if (defaultValue)
       setDefaultValue();
});

const selectionChanged = (e) => {
  if (selectionMode === 'single') {
    dropDownBox.value.instance.close();
    value.value = e.selectedRowsData[0];
    emit('valueChanged', e.selectedRowsData[0]);
  } else {
    value.value = e.selectedRowsData;
    selectedData.value = e.selectedRowsData;
    emit('valueChanged', selectedData.value);
  }
};

const displayExpr = (item) => {
  if (selectionMode === 'single') {
    return item && `${item.name}${item.mvp_code && ` (${item.mvp_code})` || ''}` || null;
  } else {
    return item?.length && item.map(x => `${x.name}${x.mvp_code && ` (${x.mvp_code})` || ''}`).join(', ') || '';
  }
};

const setDefaultValue = () => {
  selectedKeys.value = [defaultValue];
  value.value = defaultValue;
  treeListRef.value.instance.selectRows(defaultValue.kod_direct, true);
};

defineExpose({
  setDefaultValue,
});

</script>

<style scoped>

</style>
